<template>
    <!-- Panel -->
    <!--
        Source Tailwind UI: Two-column in full-width cards
        https://tailwindui.com/components/application-ui/forms/form-layouts#component-b5675d2efaa71ec3767969fd53fc3b66
     -->
    <div class="bg-white border rounded-md border-gray-200 px-4 py-5 sm:rounded-lg sm:p-6">
        <slot></slot>
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <!-- Column 1 -->
            <div :class="hideRightColumn ? 'md:col-span-3' : 'md:col-span-1'">
                <slot name="left-column"></slot>
            </div>

            <!-- Column 2. No fallback content: when a report moves its settings
                 into the drawer this slot is empty, and placeholder text would
                 otherwise render as if it were real UI. -->
            <div v-if="!hideRightColumn" class="mt-5 md:mt-0 md:col-span-2">
                <slot name="right-column"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "BaseReport",
    mixins: [],
    components: {},
    props: {
        hideRightColumn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    },
    watch: {

    },
    computed: {

    },
}

</script>

<style scoped>

</style>